module.exports = __webpack_public_path__ + "img/businessman.f02b279f.png";